import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icons } from '../icons/icons.esm.js';
import { ButtonBase } from './button-base/button-base.esm.js';

const _Button = ({ variant = 'primary', children, className, icon = '', size = 'lg', withStroke = true, ...rest })=>{
    const _className = classNames(className, {
        'btn-icon': icon
    });
    const ButtonIcon = Icons?.[icon];
    return jsx(ButtonBase, {
        withStroke: withStroke,
        className: _className,
        variant: variant,
        size: size,
        ...rest,
        children: ButtonIcon ? jsx(ButtonIcon, {}) : children
    });
};
const components = {
    Primary: (props)=>jsx(Button, {
            ...props,
            variant: "primary"
        }),
    Secondary: (props)=>jsx(Button, {
            ...props,
            variant: "secondary"
        }),
    Outline: (props)=>jsx(Button, {
            ...props,
            variant: "outline"
        })
};
const Button = Object.assign(_Button, components);

export { Button, _Button };
